import { render, staticRenderFns } from "./bread-path.vue?vue&type=template&id=811176f6&scoped=true"
import script from "./bread-path.vue?vue&type=script&lang=js"
export * from "./bread-path.vue?vue&type=script&lang=js"
import style0 from "./bread-path.vue?vue&type=style&index=0&id=811176f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811176f6",
  null
  
)

export default component.exports